import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import { JhiItemCount, JhiPagination, TextFormat, Translate, getSortState } from 'react-jhipster';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Table } from 'reactstrap';

import { APP_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { PageHeader } from 'app/shared/components/page-header/PageHeader';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { ASC, DEFAULT_ITEMS_PER_PAGE, DESC, SORT } from 'app/shared/util/pagination.constants';
import { getEntities } from './report-daily-vehicle.reducer';

export const ReportDailyVehicle = (props: RouteComponentProps<{ url: string }>) => {
  const dispatch = useAppDispatch();

  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getSortState(props.location, DEFAULT_ITEMS_PER_PAGE, 'id'), props.location.search)
  );

  const reportDailyVehicleList = useAppSelector(state => state.reportDailyVehicle.entities);
  const loading = useAppSelector(state => state.reportDailyVehicle.loading);
  const totalItems = useAppSelector(state => state.reportDailyVehicle.totalItems);

  const getAllEntities = () => {
    dispatch(
      getEntities({
        page: paginationState.activePage - 1,
        size: paginationState.itemsPerPage,
        sort: `${paginationState.sort},${paginationState.order}`,
      })
    );
  };

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (props.location.search !== endURL) {
      props.history.replace(`${props.location.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort]);

  useEffect(() => {
    const params = new URLSearchParams(props.location.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [props.location.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const { match } = props;

  return (
    <div>
      <PageHeader
        headingId="report-daily-vehicle-heading"
        headingDataCy="ReportDailyVehicleHeading"
        contentKey="fleetSenseApp.reportDailyVehicle.home.title"
        buttonTextKey="fleetSenseApp.reportDailyVehicle.home.createLabel"
        match={match}
      />
      <div className="table-responsive">
        {reportDailyVehicleList && reportDailyVehicleList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="fleetSenseApp.reportDailyVehicle.id">ID</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('created')}>
                  <Translate contentKey="fleetSenseApp.reportDailyVehicle.createdDate">Created</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('totalAlerts')}>
                  <Translate contentKey="fleetSenseApp.reportDailyVehicle.totalAlerts">Total Alerts</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('totalSensorAlerts')}>
                  <Translate contentKey="fleetSenseApp.reportDailyVehicle.totalSensorAlerts">Total Sensor Alerts</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('totalFenceCircleAlerts')}>
                  <Translate contentKey="fleetSenseApp.reportDailyVehicle.totalFenceCircleAlerts">Total Fence Circle Alerts</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('uptime')}>
                  <Translate contentKey="fleetSenseApp.reportDailyVehicle.uptime">Uptime</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('idletime')}>
                  <Translate contentKey="fleetSenseApp.reportDailyVehicle.downtime">Downtime</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('odometer')}>
                  <Translate contentKey="fleetSenseApp.reportDailyVehicle.odometer">Odometer</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('travelledDistance')}>
                  <Translate contentKey="fleetSenseApp.reportDailyVehicle.travelledDistance">Travelled Distance</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('maximumSpeed')}>
                  <Translate contentKey="fleetSenseApp.reportDailyVehicle.maximumSpeed">Maximum Speed</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('minimumSpeed')}>
                  <Translate contentKey="fleetSenseApp.reportDailyVehicle.minimumSpeed">Minimum Speed</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('averageSpeed')}>
                  <Translate contentKey="fleetSenseApp.reportDailyVehicle.averageSpeed">Average Speed</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('maximumLoad')}>
                  <Translate contentKey="fleetSenseApp.reportDailyVehicle.maximumLoad">Maximum Load</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('minimumLoad')}>
                  <Translate contentKey="fleetSenseApp.reportDailyVehicle.minimumLoad">Minimum Load</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('averageLoad')}>
                  <Translate contentKey="fleetSenseApp.reportDailyVehicle.averageLoad">Average Load</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('absActivations')}>
                  <Translate contentKey="fleetSenseApp.reportDailyVehicle.absActivations">Abs Activations</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('rssActivations')}>
                  <Translate contentKey="fleetSenseApp.reportDailyVehicle.rssActivations">Rss Activations</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('brakeActivations')}>
                  <Translate contentKey="fleetSenseApp.reportDailyVehicle.brakeActivations">Brake Activations</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="fleetSenseApp.reportDailyVehicle.truckImplement">Truck Implement</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="fleetSenseApp.reportDailyVehicle.company">Company</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="fleetSenseApp.reportDailyVehicle.user">User</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {reportDailyVehicleList.map((reportDailyVehicle, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`${match.url}/${reportDailyVehicle.id}`} color="link" size="sm">
                      {reportDailyVehicle.id}
                    </Button>
                  </td>
                  <td>{reportDailyVehicle.created ? <TextFormat type="date" value={reportDailyVehicle.created} format={APP_DATE_FORMAT} /> : null}</td>
                  <td>{reportDailyVehicle.totalAlerts}</td>
                  <td>{reportDailyVehicle.totalSensorAlerts}</td>
                  <td>{reportDailyVehicle.totalFenceCircleAlerts}</td>
                  <td>{reportDailyVehicle.uptime}</td>
                  <td>{reportDailyVehicle.idletime}</td>
                  <td>{reportDailyVehicle.odometer}</td>
                  <td>{reportDailyVehicle.travelledDistance}</td>
                  <td>{reportDailyVehicle.maximumSpeed}</td>
                  <td>{reportDailyVehicle.minimumSpeed}</td>
                  <td>{reportDailyVehicle.averageSpeed}</td>
                  <td>{reportDailyVehicle.maximumLoad}</td>
                  <td>{reportDailyVehicle.minimumLoad}</td>
                  <td>{reportDailyVehicle.averageLoad}</td>
                  <td>{reportDailyVehicle.absActivations}</td>
                  <td>{reportDailyVehicle.rssActivations}</td>
                  <td>{reportDailyVehicle.brakeActivations}</td>
                  <td>
                    {reportDailyVehicle.truckImplement ? (
                      <Link to={`truck-implement/${reportDailyVehicle.truckImplement.id}`}>{reportDailyVehicle.truckImplement.licensePlate}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>{reportDailyVehicle.company ? <Link to={`company/${reportDailyVehicle.company.id}`}>{reportDailyVehicle.company.name}</Link> : ''}</td>
                  <td>{reportDailyVehicle.user ? reportDailyVehicle.user.login : ''}</td>
                  <td className="text-right">
                    <div className="btn-group flex-btn-group-container">
                      <Button tag={Link} to={`${match.url}/${reportDailyVehicle.id}`} color="info" size="sm" data-cy="entityDetailsButton">
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`${match.url}/${reportDailyVehicle.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`${match.url}/${reportDailyVehicle.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="fleetSenseApp.reportDailyVehicle.home.notFound">No Report Daily Vehicles found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={reportDailyVehicleList && reportDailyVehicleList.length > 0 ? '' : 'd-none'}>
          <Row className="justify-content-center">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </Row>
          <Row className="justify-content-center">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </Row>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default ReportDailyVehicle;
